/* ========== ~~~~~~~~~~ SCREEN STATUS : ACTIONS ~~~~~~~~~~ ========== */
// ACTION
// utilized by reducers as a call to action to perform some kind of update to application state
// utilized in "_container" components and reducers


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const DISPLAY_SCREEN = 'DISPLAY_SCREEN';
export const displayScreen = (screen) => ({
    type: DISPLAY_SCREEN,
    screen
});
